var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle43ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M55 35v10l-8.274.752A2.5 2.5 0 0 1 44 43.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L55 35Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m53 34 .445.223A2.813 2.813 0 0 1 55 36.738v6.524c0 1.065-.602 2.039-1.555 2.515L53 46"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M5 45V35l8.274-.752A2.5 2.5 0 0 1 16 36.738v6.524a2.5 2.5 0 0 1-2.726 2.49L5 45Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m7 46-.445-.223A2.813 2.813 0 0 1 5 43.262v-6.524c0-1.065.602-2.039 1.555-2.515L7 34"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M37.5 36a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-5a1.5 1.5 0 0 1 1.5-1.5h15Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M30.5 24.5A2.5 2.5 0 0 0 33 27h11.5a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5h-14v12.5ZM13 24.5a2.5 2.5 0 0 0 2.5 2.5H27a2.5 2.5 0 0 0 2.5-2.5V12h-14a2.5 2.5 0 0 0-2.5 2.5v10Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M13 22v-7.5a2.5 2.5 0 0 1 2.5-2.5h29a2.5 2.5 0 0 1 2.5 2.5V22"
})));
SvgRectangle43ASelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle43ASelected);
export default ForwardRef;